import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { format } from 'date-fns';

const initialState = {
    error: null,
    message: false,
	messages: [],
	exception: false
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STATUSBAR_SET_MESSAGE:
            if(state.message) {
                return updateObject(state, { 
                    message: action.message,
                    messages: [ { [(state.messages.length+1)+""]: format(new Date(), "HH:mm:ss"), ...state.message }, ...state.messages ],
                });
            }
            return updateObject(state, { message: action.message });
		case actionTypes.STATUSBAR_RESET_MESSAGE:
            if(state.message) {
                return updateObject(state, { 
                    messages: [ { [(state.messages.length+1)+""]: format(new Date(), "HH:mm:ss"), ...state.message }, ...state.messages ],
                    message: false
                });
            }
            return state;
		case actionTypes.STATUSBAR_SET_EXCEPTION:
            return updateObject(state, { exception: action.exception });
		case actionTypes.STATUSBAR_RESET_EXCEPTION:
            return updateObject(state, { exception: false });
        default: 
            return state;
    }
}

export default reducer;
